import * as React from 'react';
import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as style from './ContactsList.css';
import { ContactsListCallButton } from '../../../../containers/PromoDetails/parts/ContactsListCallButton';
import { Author } from '../Author';
import { INewbuildingSeller } from '../../../../types/newbuilding/seller';
import { INewbuildingBuilder } from '../../../../types/newbuilding/builder';

interface IContactsListProps {
  builders: INewbuildingBuilder[];
  sellers: INewbuildingSeller[];
  onShowPhoneClick(): void;
  authorDescription: string | null;
}

export const ContactsList = ({ builders, sellers, onShowPhoneClick, authorDescription }: IContactsListProps) => {
  return (
    <div className={style['container']}>
      <div>
        <UIHeading4>Застройщики, участвующие в проекте</UIHeading4>
        {authorDescription && (
          <div className={style['author-description']}>
            <UIText2 color="gray60_100">{authorDescription}</UIText2>
          </div>
        )}
      </div>
      <div className={style['list']}>
        {builders.map(builder => (
          <Author
            key={builder.id}
            label="Застройщик"
            name={builder.name}
            logoUrl={builder.logoUrl}
            contactsButton={
              <ContactsListCallButton onClick={onShowPhoneClick} buttonText="Позвонить застройщику" contact={builder} />
            }
          />
        ))}
        {sellers.map(seller => (
          <Author
            key={seller.name}
            label="Представитель застройщика"
            name={seller.name as string}
            logoUrl={seller.avatarUrl}
            contactsButton={
              <ContactsListCallButton
                onClick={onShowPhoneClick}
                buttonText="Позвонить представителю"
                contact={seller}
              />
            }
          />
        ))}
      </div>
    </div>
  );
};
